import { useState } from "react";
import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, OutlinedInput, Switch, TextField, Tooltip } from "@mui/material"
import { CameraAlt as CameraAltIcon, VisibilityOff as VisibilityOffIcon, Visibility as VisibilityIcon } from "@mui/icons-material"
import { SketchPicker } from "react-color"
import { ColorPicker as ColorPickerRCGP } from 'react-color-gradient-picker';
import ColorPicker from 'react-best-gradient-color-picker'

export const TextInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  tooltip = "",
  inputProps,
  endAdornment,
  startAdornment,
  size,
  instance,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction
}) => {
  const [values, setValues] = useState(false)

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <Tooltip title={tooltip}>
      <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    </Tooltip>
    {type !== "password" ?
      <TextField
        fullWidth
        id={id}
        margin="dense"
        type={type}
        size={(size !== undefined && size !== null) ? size : "size"}
        name={id}
        InputProps={{
          inputProps: (inputProps !== undefined && inputProps !== null) ? inputProps : {},
          endAdornment: (endAdornment !== undefined && endAdornment !== null) ? <InputAdornment position="end">{endAdornment.value}</InputAdornment> : null,
          startAdornment: (startAdornment !== undefined && startAdornment !== null) ? <InputAdornment position="start">{startAdornment.value}</InputAdornment> : null
        }}
        value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
        {...register(id)}
        error={errors[id] ? true : false}
        onChange={changeDataFunction} />
      :
      <FormControl variant="standard" fullWidth>
        <OutlinedInput
          id={id}
          size="small"
          type={values ? 'text' : 'password'}
          name={id}
          value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
          {...register(id)}
          error={errors[id] ? true : false}
          onChange={changeDataFunction}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={() => setValues(!values)}
                onMouseDown={(event) => { event.preventDefault() }}
                edge="end"
              >
                {values ? <VisibilityOffIcon /> : <VisibilityIcon />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    }
  </>)
}

export const SelectInputC = ({
  id,
  name,
  type,
  required,
  containerOptions,
  defaultValue,
  tooltip = "",
  size,
  instance,
  containerSelectOptions,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction
}) => {

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <Tooltip title={tooltip}>
      <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    </Tooltip>
    <TextField
      fullWidth
      id={id}
      select
      margin="dense"
      size={(size !== undefined && size !== null) ? size : "size"}
      name={id}
      value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
      {...register(id)}
      error={errors[id] ? true : false}
      onChange={changeDataFunction}>
      {containerSelectOptions[containerOptions].map((opt, index) => (
        <MenuItem key={`${index}-${opt.value}`} value={opt.value}>{opt.label}</MenuItem>
      ))}
    </TextField>
  </>)
}

export const SwitchC = ({
  id,
  name,
  required,
  tooltip = "",
  instance,
  checkIfPropertyIsInInstance,
  register,
  changeDataFunction
}) => {

  if (id === undefined || id === null) {
    return <>Falta el atributo id</>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  }

  return (<>
    <Tooltip title={tooltip}>
      <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    </Tooltip>
    <Switch edge="end" required={required} inputProps={{ 'aria-labelledby': `switch-list-label-${id}` }}
      onClick={() => changeDataFunction(id)}
      checked={checkIfPropertyIsInInstance(id) ? instance[id] : false}
      {...register(id)}
    />
  </>)
}

export const ImageInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  tooltip = "",
  size,
  instance,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction,
  setFieldImageManager,
  openImageManager
}) => {

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <Tooltip title={tooltip}>
      <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    </Tooltip>
    <div style={{ display: "flex", alignItems: "center" }}>
      <div style={{ display: "none" }}>
        <TextField
          fullWidth
          id={id}
          margin="dense"
          type="text"
          size={(size !== undefined && size !== null) ? size : "size"}
          name={id}
          value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
          {...register(id)}
          error={errors[id] ? true : false}
          onChange={changeDataFunction} />
      </div>
      {instance[id] !== null && instance[id] !== undefined && instance[id] !== "" ?
        <img src={instance[id]} style={{ width: 100 }} />
        : null}
      <IconButton onClick={() => { setFieldImageManager(id); openImageManager(); }}><CameraAltIcon /></IconButton>
    </div>
  </>)
}

export const ColorInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  size,
  instance,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction,
  changeCompletePicker
}) => {

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    <TextField
      fullWidth
      id={id}
      margin="dense"
      type="text"
      size={(size !== undefined && size !== null) ? size : "size"}
      name={id}
      value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
      {...register(id)}
      error={errors[id] ? true : false}
      onChange={changeDataFunction}
      sx={{
        input: {
          color: "#a3a3a3",
          backgroundColor: checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue,
        }
      }}
    />
    <SketchPicker presetColors={[]}
      color={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
      onChangeComplete={(color) => changeCompletePicker(color, id)}
    />
  </>)
}

export const ColorInputC1 = ({
  id,
  name,
  type,
  required,
  defaultValue,
  tooltip = "",
  size,
  instance,
  checkIfPropertyIsInInstance,
  register,
  errors,
  changeDataFunction,
  changeCompletePicker
}) => {
  const [displayColorPicker, setDisplayColorPicker] = useState(false)

  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (type === undefined || type === null) {
    return <p>Falta el atributo type</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPicker)
  };

  const handleClose = () => {
    setDisplayColorPicker(false)
  };

  const handleChange = (color) => {
    changeCompletePicker(color, id)
  };

  return (<>
    <Tooltip title={tooltip}>
      <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    </Tooltip>
    <div>
      <TextField
        style={{ width: "65px" }}
        id={id}
        margin="dense"
        type="color"
        size={size}
        name={id}
        value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
        {...register(id)}
        error={errors[id] ? true : false}
        onChange={changeDataFunction} />
    </div>
    {/* <div>
      <div style={{ padding: '5px', background: '#fff', borderRadius: '1px', boxShadow: '0 0 0 1px rgba(0,0,0,.1)', display: 'inline-block', cursor: 'pointer' }} onClick={handleClick}>
        <div style={{ width: '36px', height: '14px', borderRadius: '2px', background: checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue }} />
      </div>
      {displayColorPicker ? <div style={{ position: 'absolute', zIndex: '2' }}>
        <div style={{ position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' }} onClick={handleClose} />
        <SketchPicker color={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue} onChange={handleChange} />
      </div> : null}
    </div> */}
  </>)
}

export const ColorGradientInputC = ({
  id,
  name,
  type,
  required,
  defaultValue,
  tooltip = "",
  size = 3,
  instance,
  checkIfPropertyIsInInstance,
  changeColorGradient
}) => {
  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <Tooltip title={tooltip}>
      <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    </Tooltip>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <ColorPickerRCGP onStartChange={changeColorGradient} onChange={changeColorGradient} onEndChange={changeColorGradient} gradient={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue} isGradient
      />
    </div>
  </>)
}

export const ColorGradientInputC1 = ({
  id,
  name,
  type,
  required,
  defaultValue,
  tooltip = "",
  size = 3,
  instance,
  checkIfPropertyIsInInstance,
  changeColorGradient
}) => {
  if (id === undefined || id === null) {
    return <p>Falta el atributo id</p>
  } else if (name === undefined || name === null) {
    return <p>Falta el atributo name</p>
  } else if (defaultValue === undefined || defaultValue === null) {
    return <p>Falta el atributo defaultValue</p>
  }

  return (<>
    <Tooltip title={tooltip}>
      <InputLabel htmlFor={id} required={required} style={{ fontSize: 14 }}>{name}</InputLabel>
    </Tooltip>
    <div style={{ display: "flex", justifyContent: "center" }}>
      <ColorPicker
        value={checkIfPropertyIsInInstance(id) ? instance[id] : defaultValue}
        onChange={(color) => changeColorGradient(color, id)}
        hideAdvancedSliders={true}
        hideColorGuide={true}
        hideInputType={true}
        height={100}
      />
    </div>
  </>)
}